import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Section } from '../..';

const Employments = ({ field, translations }) => {
    const getLabel = ({ startDate, finishDate, city }) => {
        const cityDisplayed = city ? `${city}` : 'brak odpowiedzi';
        return `${moment(startDate).format('MMMM YYYY')} - ${!finishDate ? translations.present : moment(finishDate).format('MMMM YYYY')}, ${cityDisplayed}`;
    };

    const getDesc = ({ positionName, companyName, employmentCategories, responsibilities }) => `${[positionName, companyName, employmentCategories.map((ec) => ec.name).join(', '), responsibilities].join('\n')}`;
    return (
        <Section.Conditional
            condition={Boolean(field.employmentHistories.length)}
            title={translations.employments}
        >
            {({ renderField }) => (
                <>
                    {field.employmentHistories.map(
                        (employment) => renderField(getLabel(employment), getDesc(employment), null, `employment_${employment.id}`)
                    )}
                </>
            )}
        </Section.Conditional>
    );
};
Employments.propTypes = {
    field: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default Employments;
